export default __webpack_public_path__ + "static/media/mentors.6c4b18be.jpg";